module.exports = __webpack_public_path__ + "static/media/kneehyperextension_normal_left.62ad8c27.png";